import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { CombinedReducers } from 'app_events/index';

import './StudentDashboardLearningPath.scss'
import { IFetchScheduling } from 'app_types/campus/academic/schedulingTypes';
import SchedulingService from 'app_services/campus/academic/schedulingService';
import LearningPath from 'app_components/modules/LearningPath/LearningPath';
import { Accordion, Card } from 'react-bootstrap';
import { AiOutlineCloseCircle, AiOutlinePlusCircle } from 'react-icons/ai';

interface IStudentDashboardLearningPathProps {
  id?: string
  toggleId?: string
}

const StudentDashboardLearningPath: FC<IStudentDashboardLearningPathProps> = ({ id, toggleId }) => {
  const { courseSelected } = useSelector((state: CombinedReducers) => state.courses)
  const [courseScheduling, setCourseScheduling] = useState<IFetchScheduling>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const schedulingService = useMemo(() => new SchedulingService(), [])
  const [activeKey, setActiveKey] = useState<string | undefined>(undefined)

  const getCourseScheduling = useCallback(async (moodleId: string, courseSchedulingId: string) => {
    setIsLoading(true)
    const dataResponse = await schedulingService.fetchSchedulingData({
      moodle_id: moodleId,
      courseSchedulingId,
    }, {showError: false})
    if (dataResponse && dataResponse?.program && dataResponse?.courses) {
      setCourseScheduling(dataResponse)
    }
    setIsLoading(false)
  }, [schedulingService])

  useEffect(() => {
    if (courseSelected?._id) {
      getCourseScheduling(courseSelected?._id, courseSelected?.courseScheduling)
    }
  }, [courseSelected, getCourseScheduling])

  const renderIcon = () => {
    if (activeKey) {
      return (<AiOutlineCloseCircle size={25} />)
    }
    return (<AiOutlinePlusCircle size={25} />)
  }

  const handleOnSelect = (e: any) => {
    setActiveKey(e)
  }

  return (
    <div id={id} className="student-dashboard-learning-path--layout">
      <Accordion activeKey={activeKey} onSelect={handleOnSelect}>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Card.Header} id={toggleId} eventKey={'0'}>
              <div>Ruta de aprendizaje</div>
              <div className='icon'>
                {renderIcon()}
              </div>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <LearningPath loading={isLoading} learningWay={courseScheduling} />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  )
}

export default StudentDashboardLearningPath
